<template>
    <el-container class="detail-page">
        <el-header>
            <div>
                {{$t('default.title')}}
            </div>
            <div>
                <el-button @click.native.prevent="updateUserSetting" type="success"
                           :disabled="!settingsLoaded || loading || buttonDisabledStatus || pageHaveChange !== 1">{{$t('common.save')}}
                </el-button>
            </div>
        </el-header>

        <el-main>
            <el-alert v-if="loadError !== ''" :title="loadError" type="error" :closable="false" show-icon></el-alert>
            <div v-else-if="settingsLoaded">
                <el-form class="default-settings-form" label-position="left" label-width="140px" :model="userSetting" v-loading="loading" :rules="loginRules" ref="loginForm">

                    <el-row>
                        <el-col :span="24">
                            <el-card>
                                <el-form-item style="width: 67%" :label="$t('default.emailMessage')">
                                    <el-input type="textarea" :autosize="{minRows: 2}" :placeholder="$t('default.enterDescription')"
                                              v-model="userSetting.emailMessage"></el-input>
                                </el-form-item>
                                <el-form-item prop="emailCc" :label="$t('default.emailCc')">
                                    <el-input type="text" v-model="userSetting.emailCc"></el-input>
                                </el-form-item>
                                <el-form-item prop="emailBcc" :label="$t('default.emailBcc')">
                                    <el-input type="text" v-model="userSetting.emailBcc"></el-input>
                                </el-form-item>
                                <div>
                                    {{$t('default.emailTip')}}
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>


                    <el-row style="margin-top: 20px;">
                        <el-col :span="24">
                            <el-card>
                                <el-row>
                                    <el-col :span="16" class="biaoti">
                                        <span>{{$t('default.defaultComments')}}</span>
                                    </el-col>
                                </el-row>
                                <el-divider></el-divider>
                                <el-form-item style="width: 67%" :label="$t('default.invoice')">
                                    <el-input type="textarea" :autosize="{minRows: 2}" :placeholder="$t('default.enterDescription')"
                                              v-model="userSetting.invoiceComment"></el-input>
                                </el-form-item>

                                <el-form-item style="width: 67%" :label="$t('default.estimate')">
                                    <el-input type="textarea" :autosize="{minRows: 2}" :placeholder="$t('default.enterDescription')"
                                              v-model="userSetting.estimateComment"></el-input>
                                </el-form-item>

                                <el-form-item style="width: 67%" :label="$t('default.purchaseOrder')">
                                    <el-input type="textarea" :autosize="{minRows: 2}" :placeholder="$t('default.enterDescription')"
                                              v-model="userSetting.purchaseOrderComment"></el-input>
                                </el-form-item>

                                <el-form-item style="width: 67%" :label="$t('default.creditMemo')">
                                    <el-input type="textarea" :autosize="{minRows: 2}" :placeholder="$t('default.enterDescription')"
                                              v-model="userSetting.creditMemoComment"></el-input>
                                </el-form-item>
                            </el-card>
                        </el-col>
                    </el-row>

                </el-form>

            </div>
        </el-main>

    </el-container>
</template>

<script>
    import {timest, validateEmailCanKong} from '@/utils/validate'
    import {replaceStoredSetting, syncCompanySelection} from '@/utils/company'

    export default {
        methods: {
            settingsSnapshot() {
                return JSON.stringify({
                    emailMessage: this.userSetting.emailMessage,
                    emailCc: this.userSetting.emailCc,
                    emailBcc: this.userSetting.emailBcc,
                    invoiceComment: this.userSetting.invoiceComment,
                    estimateComment: this.userSetting.estimateComment,
                    purchaseOrderComment: this.userSetting.purchaseOrderComment,
                    creditMemoComment: this.userSetting.creditMemoComment
                });
            },
            updateDirtyState() {
                this.pageHaveChange = this.initialSettingsSnapshot !== ''
                    && this.settingsSnapshot() !== this.initialSettingsSnapshot ? 1 : 0;
            },
            async queryUserSetting() {
                this.loading = true;
                this.settingsLoaded = false;
                this.loadError = '';
                try {
                    const response = await this.$axios.post('query_setting_and_company', {
                        params: {}
                    });
                    if (response.data.errorCode !== 0) {
                        throw new Error('Setting query failed');
                    }
                    const selectedData = syncCompanySelection(response.data);
                    if (selectedData == null) {
                        throw new Error('Selected company data is missing');
                    }
                    this.userSetting = selectedData.setting;
                    this.initialSettingsSnapshot = this.settingsSnapshot();
                    this.pageHaveChange = 0;
                    this.settingsLoaded = true;
                    this.buttonDisabledStatus = false;

                    this.$watch('userSetting', function () {
                        this.updateDirtyState();
                    }, {deep: true});
                } catch {
                    this.loadError = this.$t('common.loadFailed');
                } finally {
                    this.loading = false;
                }
            },
            updateUserSetting(flag, next) {
                if (!this.settingsLoaded || this.loading || this.buttonDisabledStatus || this.pageHaveChange !== 1) {
                    return;
                }
                let self = this;
                this.$refs.loginForm.validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        this.buttonDisabledStatus = true;
                        this.$axios.post('update_setting', {
                            params: {
                                emailMessage: this.userSetting.emailMessage,
                                emailCc: this.userSetting.emailCc,
                                emailBcc: this.userSetting.emailBcc,
                                invoiceComment: this.userSetting.invoiceComment,
                                estimateComment: this.userSetting.estimateComment,
                                purchaseOrderComment: this.userSetting.purchaseOrderComment,
                                creditMemoComment: this.userSetting.creditMemoComment,
                                innerUUID: this.userSetting.innerUUID,
                                companyUUID: this.userSetting.companyUUID,
                                accessDate: timest()
                            }
                        }).then(response => {
                            this.loading = false;
                            self.buttonDisabledStatus = false;
                            if (response.data.errorCode === 0) {

                                this.initialSettingsSnapshot = this.settingsSnapshot();
                                this.pageHaveChange = 0;

                                let tempUserSetting = JSON.parse(localStorage.getItem('userSetting'));
                                tempUserSetting.emailMessage = this.userSetting.emailMessage;
                                tempUserSetting.emailCc = this.userSetting.emailCc;
                                tempUserSetting.emailBcc = this.userSetting.emailBcc;
                                tempUserSetting.invoiceComment = this.userSetting.invoiceComment;
                                tempUserSetting.estimateComment = this.userSetting.estimateComment;
                                tempUserSetting.purchaseOrderComment = this.userSetting.purchaseOrderComment;
                                tempUserSetting.creditMemoComment = this.userSetting.creditMemoComment;
                                replaceStoredSetting(tempUserSetting);

                                this.$message.success({
                                    message: this.$t('common.updateSuccess'),
                                    center: true
                                });
                                if (flag === 100) {
                                    next();
                                }
                            } else {
                                this.$message.error(this.$t('common.saveFailed'));
                            }
                        }).catch(function () {
                            self.loading = false;
                            self.buttonDisabledStatus = false;
                            self.$message.error(self.$t('common.systemError'));
                        })
                    } else {
                        this.$message.error({
                            message: this.$t('common.validEmail'),
                            center: true
                        });
                    }
                })
            }
        },
        data() {
            const validEmail = (rule, value, callback) => {
                if (!validateEmailCanKong(value)) {
                    callback(new Error(this.$t('common.validEmail')))
                } else {
                    callback()
                }
            };
            return {
                userSetting: {},
                buttonDisabledStatus: true,
                pageHaveChange: 0,
                loading: true,
                settingsLoaded: false,
                loadError: '',
                initialSettingsSnapshot: '',
                loginRules: {
                    emailCc: [{required: false, trigger: 'blur', validator: validEmail}],
                    emailBcc: [{required: false, trigger: 'blur', validator: validEmail}]
                }
            }
        },
        mounted() {
            this.queryUserSetting();
        },
        beforeRouteLeave: function (to, from, next) {
            if (this.pageHaveChange === 1) {
                next(false);
                this.$confirm(this.$t('common.unsavedChangesMsg'), this.$t('common.saveChangesTitle'), {
                    confirmButtonText: this.$t('common.confirmSave'),
                    cancelButtonText: this.$t('common.discard'),
                    distinguishCancelAndClose: true,
                    type: 'warning'
                }).then(() => {
                    // 选择确定
                    this.updateUserSetting(100, next);
                }).catch(function (action) {
                    if (action === 'cancel') {
                        next();
                    }
                });
            } else {
                next();
            }
        }
    }
</script>
<style scoped>
    /deep/ .el-header {
        background-color: #f7f7f9;
        font-size: 25px;
        font-weight: 600;
        height: 100px !important;
        display: flex;
        justify-content: space-between;
        padding: 30px;
    }

    .biaoti {
        font-size: 24px;
        padding-left: 1%;
    }

    /deep/ .el-input__inner {
        width: 64%;
        border-style: none none solid none;
        background-color: #ffffff;
        border-radius: 0px;
    }

    /deep/ .taxListButton {
        border-style: none none solid none;
        background-color: white;
        border-radius: 0px;
        width: 15%;
        text-align: left;
    }

    .taxItemList {
        margin-bottom: 10px;
    }

    .taxListform {
        margin-left: 10%;
        margin-top: 20px;
    }

    /deep/ .el-select {
        display: block;
    }

    /deep/ .el-input__suffix {
        left: 0;
    }

    /*去掉textarea右下角样式*/
    /deep/ .el-textarea__inner {
        resize: none;
    }

    @media (max-width: 640px) {
        /deep/ .el-header {
            height: 86px !important;
            padding: 28px 72px 20px 20px;
        }

        /deep/ .el-main {
            padding: 12px;
        }

        .default-settings-form >>> .el-form-item {
            display: block;
            width: 100% !important;
        }

        .default-settings-form >>> .el-form-item__label {
            float: none;
            width: 100% !important;
            padding-right: 0;
            line-height: 24px;
        }

        .default-settings-form >>> .el-form-item__content {
            margin-left: 0 !important;
        }

        .default-settings-form >>> .el-input,
        .default-settings-form >>> .el-textarea {
            width: 100%;
        }

        .default-settings-form >>> .el-input__inner {
            width: 100%;
        }
    }
</style>
<style>
    .el-button--success {
        background-color: #0D7DF7;
        border-color: #0D7DF7;
    }

    .el-button--success:focus, .el-button--success:hover {
        background-color: #0D7DF7;
        border-color: #0D7DF7;
    }
</style>
